import { Box, Button, Layer, Paragraph } from 'grommet'
import { CircleQuestion } from 'grommet-icons'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { TranslatedExternalLink } from '../../translation/TranslatedExternalLink'
import LayerContent from '../../ui/LayerContent'

const CenteredList = styled.ol`
  text-align: center;
  margin: 0;
  padding: 0;
  list-style-position: inside;

  li {
    display: inline;
    
    &::after {
      display: inline;
      content: '; ';
    }

    &:last-child::after {
      content: '.';
    }
  }
`

export default function CollectedDataInfo() {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const intl = useIntl()

  const close = () => setIsOpen(false)
  const open = () => setIsOpen(true)

  return (
    <>
      <Paragraph size="medium">
        <Button
          plain
          onClick={open}
          title={intl.formatMessage({ id: 'common.moreInfo' })}
          label={
            <>
              <FormattedMessage id="login.data.whyDoWeCollectTitle" />{' '}
              <CircleQuestion />
            </>
          }
        />
      </Paragraph>

      {isOpen && (
        <Layer
          id="collected-data-info"
          position="center"
          onClickOutside={close}
          onEsc={close}
        >
          <LayerContent>
            <Box pad="medium" justify="start" align="center" overflow="auto">
              <Paragraph size="large" textAlign="center">
                <FormattedMessage
                  id="login.data.whyDoWeCollect"
                  values={{
                    link: (text: string) => (
                      <TranslatedExternalLink
                        linkId="login.data.whyDoWeCollectLink"
                        text={text}
                      />
                    ),
                  }}
                />
              </Paragraph>

              <Paragraph size="medium" textAlign="center">
                <CenteredList type="i">
                  {[
                    'photo',
                    'fullName',
                    'signature',
                    'birthDate',
                    'nationality',
                    'documentEntity',
                    'nif',
                    'occupation',
                    'address',
                    'placeOfBirth',
                    'otherNationalities',
                  ].map((translationId, index) => (
                    <li key={index}>
                      {intl.formatMessage({ id: `login.data.${translationId}` })}
                    </li>
                  ))}
                </CenteredList>
              </Paragraph>

              <Paragraph size="large" textAlign="center">
                <FormattedMessage id="login.data.phoneNumberInfo" />
              </Paragraph>

              <Button
                primary
                onClick={close}
                label={intl.formatMessage({ id: 'common.close' })}
              />
            </Box>
          </LayerContent>
        </Layer>
      )}
    </>
  )
}
